/**
 * This is a port of the phxDuration filter.
 */
// Pad number to two digits.
export function pad(n) {
    if (n <= 0) {
        return '00';
    }
    else if (n < 10) {
        return `0${n}`;
    }
    else {
        return n.toString();
    }
}
// toHMS converts seconds integer into hh:mm:ss string
// (Originally used to display duration on Bio videos)
export function toHMS(seconds) {
    if (typeof seconds !== 'number' || seconds < 0)
        return null;
    const TEN_MINUTE_IN_SEC = 600;
    const ONE_HOUR_IN_SEC = 3600;
    const TEN_HOUR_IN_SEC = 36000;
    const isoString = new Date(seconds * 1000).toISOString().substring(11, 19);
    if (seconds < TEN_MINUTE_IN_SEC) {
        // m:ss
        return isoString.substring(4);
    }
    else if (seconds < ONE_HOUR_IN_SEC) {
        // mm:ss
        return isoString.substring(3);
    }
    else if (seconds < TEN_HOUR_IN_SEC) {
        // h:mm:ss
        return isoString.substring(1);
    }
    else {
        // hh:mm:ss
        return isoString;
    }
}
export default {
    toHMS,
    pad,
};
//# sourceMappingURL=duration.js.map